import axios from 'axios'
import { topQuestionSlug, topQuestion } from '@/modules/config/zendesk'

class ZendeskApi {
  constructor () {
    this.client = axios.create({
      baseURL: `https://sephora${I18n.siteCountryLs}.zendesk.com/api/v2/help_center`
    })

    this.client.defaults.headers.common = {
      'Content-Type': 'application/json'
    }
  }

  async fetchSections (params = {}) {
    const { data } = await this.client.get('/sections', { params })
    data.sections.unshift(topQuestion)
    return data
  }

  async fetchArticles (section, params = {}) {
    let query = params.query
    let url = `/sections/${section}/articles`

    if (section === topQuestionSlug) { query = topQuestionSlug }

    if (query) {
      url = '/articles/search'
      params = Object.assign(params, {
        query: query
      })
    }
    const { data } = await this.client.get(url, { params })
    return data
  }

  async fetchArticle (id, params = {}) {
    const { data } = await this.client.get(`/articles/${id}`, { params })
    return data
  }
}

export default ZendeskApi
